import { render, staticRenderFns } from "./NotificationsGroupCard.vue?vue&type=template&id=62c49dc0&scoped=true"
import script from "./NotificationsGroupCard.vue?vue&type=script&lang=js"
export * from "./NotificationsGroupCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationsGroupCard.vue?vue&type=style&index=0&id=62c49dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c49dc0",
  null
  
)

export default component.exports